import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateCompany: { company: { name: string } }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.updateCompany.company.name,
  name: 'Company',
})

const update = ({ newCompanyName, id }: { newCompanyName: string; id: string }) => {
  return client.gql
    .mutate({ mutation, variables: { input: { name: newCompanyName, id } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation updateCompanyName($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      company {
        name
        id
      }
    }
  }
`

export default { update }
